import FireAnalyticsEventModule from "../config/fireanalyticseventmodel";
import apiRequest from "../network/api";

class AppAnalytics {
  static sendEventToMetabase(identifier, eventName, attributes = {}) {
    setTimeout(() => {
      FireAnalyticsEventModule.response.event_name = eventName;
      FireAnalyticsEventModule.response.timestamp = new Date().getTime();
      FireAnalyticsEventModule.response.identifier = identifier;
      FireAnalyticsEventModule.response.attributes = attributes;
      apiRequest.callAPIs(
        apiRequest.sendEventData(FireAnalyticsEventModule.response)
      );
    }, 0);
  }
}

export default AppAnalytics;
